import { html, render } from "lit-html";

export class WheelSelector extends HTMLElement {
	static get observedAttributes() {
		return ["value", "min", "max"];
	}

	connectedCallback() {
		this.render();
	}

	attributeChangedCallback() {
		this.render();
	}

	onIncrease() {
		if (this.value < this.max) {
			this.value = this.value + 1;
			this.onChange();
		}
	}

	onDecrease() {
		if (this.value > this.min) {
			this.value = this.value - 1;
			this.onChange();
		}
	}

	onChange() {
		this.render();
		this.dispatchEvent(new CustomEvent("change", { detail: this.value }));
		this.highlightValueNode();
	}

	highlightValueNode() {
		const valueNode = this.querySelector(".esc-wheel__value");
		valueNode.classList.add("esc-wheel__value--highlighted");
		valueNode.classList.remove("esc-wheel__value--highlighted-fade-out");
		setTimeout(() => {
			valueNode.classList.add("esc-wheel__value--highlighted-fade-out");
			valueNode.classList.remove("esc-wheel__value--highlighted");
		}, 300);
		setTimeout(() => {
			valueNode.classList.remove("esc-wheel__value--highlighted-fade-out");
		}, 1000);
	}

	render() {
		const valueIdentifier =
			this.value === 1 ? this.labelSingular : this.labelPlural;
		const label = this.label || "";

		const template = html`
			<div class="esc-wheel__label">${label}</div>
			<button
				class="esc-wheel__down"
				@click=${this.onDecrease}
				?disabled=${this.value <= this.min}
			>
				<svg
					viewBox="0 0 10 10"
					enable-background="new 0 0 10 10"
					xml:space="preserve"
				>
					<path
						d="M9.625,5.751h-9.25C0.168,5.751,0,5.583,0,5.376V4.624c0-0.207,0.168-0.375,0.375-0.375h9.25C9.832,4.249,10,4.417,10,4.624 v0.752C10,5.583,9.832,5.751,9.625,5.751z"
					/>
				</svg>
			</button>
			<div class="esc-wheel__content">
				<span class="esc-wheel__value">${this.value}</span>
				<span>${valueIdentifier}</span>
			</div>
			<button
				class="esc-wheel__up"
				@click=${this.onIncrease}
				?disabled=${this.value >= this.max}
			>
				<svg
					viewBox="0 0 10 10"
					enable-background="new 0 0 10 10"
					xml:space="preserve"
				>
					<path
						d="M9.625,4.249H5.751V0.375C5.751,0.168,5.583,0,5.376,0H4.624C4.417,0,4.249,0.168,4.249,0.375v3.874H0.375 C0.168,4.249,0,4.417,0,4.624v0.752c0,0.207,0.168,0.375,0.375,0.375h3.874v3.874C4.249,9.832,4.417,10,4.624,10h0.752 c0.207,0,0.375-0.168,0.375-0.375V5.751h3.874C9.832,5.751,10,5.583,10,5.376V4.624C10,4.417,9.832,4.249,9.625,4.249z"
					/>
				</svg>
			</button>
		`;
		render(template, this, { host: this });
	}

	set value(num) {
		this.setAttribute("value", num);
	}

	get value() {
		return this.hasAttribute("value")
			? Number.parseInt(this.getAttribute("value"))
			: 0;
	}

	get min() {
		return this.getAttribute("min");
	}

	get max() {
		return this.getAttribute("max");
	}
}

customElements.define("esc-wheel", WheelSelector);
